import { Pipe, PipeTransform } from "@angular/core";


@Pipe({name: 'hyphenated', standalone: false})
export class HyphenatedPipe implements PipeTransform {
  transform(account: string): string {
   if(account?.includes('-')) {
    return account;
   }
    if(account.length === 8) {
      return `${account.slice(0, 4)}-${account.slice(4, 9)}`;
    }
    else if (account.length === 9) {
      return `${account.slice(0, 4)}-${account.slice(4, 10)}`;
    }
    else if (account.length === 7 ) {
      account='0'+account;
      return `${account.slice(0, 4)}-${account.slice(4, 9)}`;
    }
    else if (account.length === 12) {
      return `${account.slice(0, 4)}-${account.slice(4, 13)}`;
    }
    else {
      return account;
    }
  }
}
